import { render, staticRenderFns } from "./TagsSelect.vue?vue&type=template&id=acb5f770&"
import script from "./TagsSelect.vue?vue&type=script&lang=js&"
export * from "./TagsSelect.vue?vue&type=script&lang=js&"
import style0 from "./TagsSelect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports